import React, { useEffect, useState } from 'react';
import { Users, IdCard, Stethoscope, Plane, AlertOctagon } from 'lucide-react';
import { MockPageShell, MockKpi, ChartCard, MockPie, MockLine } from '../../components/MockUI';
import { Button } from '../../components/ui/button';
import api from '../../services/api';
import { toast } from 'sonner';

export function DashboardRH() {
  const [stats, setStats] = useState({
    ativos: 0, ferias: 0, afastados: 0, desligados: 0, exames_pendentes: 0, cnhs_a_vencer: 0
  });
  const [charts, setCharts] = useState({ setores: [], turnover: [] });
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const [stRes, chRes, alRes] = await Promise.all([
        api.get('/rh-dashboard/stats'),
        api.get('/rh-dashboard/charts'),
        api.get('/rh-dashboard/alerts')
      ]);
      setStats(stRes.data);
      setCharts(chRes.data);
      setAlerts(alRes.data || []);
    } catch (err) {
      toast.error('Erro ao carregar dados do RH.');
    }
  };

  const getAlertColor = (status) => {
    switch(status) {
      case 'vencido': return 'text-red-600 bg-red-100';
      case 'atencao': return 'text-amber-600 bg-amber-100';
      default: return 'text-green-600 bg-green-100';
    }
  };

  return (
    <MockPageShell title="Dashboard RH" subtitle="Pessoas, documentos e indicadores" breadcrumbs={[{ label: 'RH' }]}
      kpis={[
        <MockKpi key="1" icon={Users} label="Funcionários ativos" value={stats.ativos} tone="success" />,
        <MockKpi key="2" icon={IdCard} label="CNHs a vencer" value={stats.cnhs_a_vencer} tone="warn" />,
        <MockKpi key="3" icon={Stethoscope} label="Exames pendentes" value={stats.exames_pendentes} tone="critical" />,
        <MockKpi key="4" icon={Plane} label="Em férias" value={stats.ferias} />,
        <MockKpi key="5" icon={AlertOctagon} label="Afastados" value={stats.afastados} tone="warn" />,
      ]}
      charts={[
        <ChartCard key="1" title="Distribuição por setor"><MockPie data={charts.setores} /></ChartCard>,
        <ChartCard key="2" title="Turnover (Últimos 6 meses)"><MockLine data={charts.turnover} color="#EF4444" /></ChartCard>,
      ]}
    >
      <div className="mt-6 bg-white p-6 rounded-lg border">
        <h3 className="text-lg font-semibold text-slate-800 mb-4">Próximos Vencimentos</h3>
        {alerts.length === 0 ? (
          <p className="text-sm text-slate-500">Nenhum vencimento próximo.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left">
              <thead className="bg-slate-50 text-slate-600 font-semibold border-b">
                <tr>
                  <th className="py-3 px-4">Funcionário</th>
                  <th className="py-3 px-4">Item</th>
                  <th className="py-3 px-4">Detalhe</th>
                  <th className="py-3 px-4">Vencimento</th>
                  <th className="py-3 px-4">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {alerts.map((al, idx) => (
                  <tr key={idx} className="hover:bg-slate-50">
                    <td className="py-3 px-4">{al.employee_name}</td>
                    <td className="py-3 px-4">{al.type}</td>
                    <td className="py-3 px-4">{al.detail}</td>
                    <td className="py-3 px-4">{al.expiry_date}</td>
                    <td className="py-3 px-4">
                      <span className={`px-2 py-1 rounded-full text-xs font-semibold ${getAlertColor(al.status)}`}>
                        {al.status.toUpperCase()}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </MockPageShell>
  );
}
